exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gradient-ai-background[data-v-99fbd444]{position:relative;width:100%;height:100%;overflow:hidden;border-radius:inherit;opacity:.4}.circle[data-v-99fbd444]{position:absolute;border-radius:50%}.circle-purple[data-v-99fbd444]{width:160px;height:160px;left:10%;top:20%;background:rgba(97,86,227,.6);border-radius:50%;filter:blur(80px)}.circle-blue[data-v-99fbd444]{width:240px;height:240px;left:60%;top:60%;background-color:rgba(43,158,198,.2);filter:blur(80px)}.circle-pink[data-v-99fbd444]{width:120px;height:120px;right:5%;top:10%;background-color:hsla(8,100%,86%,.8);filter:blur(80px)}", ""]);

// exports
